





const getMeetingPhase = (phases) => {
  return phases.find((phase) => {
    return !phase.stages.every((stage) => stage.isComplete)
  })
}

export default getMeetingPhase
